<template>
    <div>
        <form action="">
            <div class="modal-card">
                <header class="modal-card-head">
                    <p v-if="companyObj.name" class="modal-card-title has-text-white">Update Company: {{companyObj.name}} </p>
                    <p v-else class="modal-card-title has-text-white"> ERROR COMPANY NAME NOT FOUND. UPDATE COMPANY NAME </p>
                    <button
                        type="button"
                        class="delete"
                        @click="$emit('close')"/>
                </header>
                <section class="modal-card-body has-background-dvodark">
                    <b-field label="Company Name">
                        <b-input
                            type="text"
                            v-model="companyObj.name"
                            >
                        </b-input>
                    </b-field>
                    <b-field label="Address">
                        <b-input
                            type="text"
                            v-model="companyObj.address"
                            >
                        </b-input>
                    </b-field>
                    <b-field label="Landing %">
                        <b-numberinput v-model="companyObj.landing_percent"  :min="0" :max="100"></b-numberinput>
                    </b-field>
                    <b-field label="Labor Cost">
                        <b-numberinput v-model="companyObj.labor_cost"  :min="0"></b-numberinput>
                    </b-field>
                    <b-field label="Phone #">
                        <b-input
                            type="text"
                            v-model="companyObj.phone_number"
                        >
                        </b-input>
                    </b-field>
                    <b-field label="Main Contact">
                        <b-input
                            type="text"
                            v-model="companyObj.main_contact"
                        >
                        </b-input>
                    </b-field>
                    <b-field label="Main Contact Email">
                        <b-input
                            type="text"
                            v-model="companyObj.main_contact_email"
                        >
                        </b-input>
                    </b-field>
                    <b-field label="Billing Contact">
                        <b-input
                            type="text"
                            v-model="companyObj.billing_contact"
                        >
                        </b-input>
                    </b-field>  
                    <b-field label="Billing Email">
                        <b-input
                            type="text"
                            v-model="companyObj.billing_email"
                        >
                        </b-input>
                    </b-field>
                    <b-field label="Sales Contact">
                        <b-input
                            type="text"
                            v-model="companyObj.sales_contact"
                        >
                        </b-input>
                    </b-field>   
                    <b-field label="Sales Contact Email">
                        <b-input
                            type="text"
                            v-model="companyObj.sales_email"
                        >
                        </b-input>
                    </b-field>
                    <b-field label="Service Center">
                        <b-input
                            type="text"
                            v-model="companyObj.service_center"
                        >
                        </b-input>
                    </b-field>

                    <b-field label="Status">
                        <b-select placeholder="Select a name" v-model="companyObj.status">
                            <option value="active">Active</option>
                            <option value="inactive">Inactive</option>
                        </b-select>
                    </b-field>                    
                    <b-field label="Discount">
                        <b-numberinput v-model="companyObj.discount"  :min="0"></b-numberinput>
                    </b-field>                    
                </section>
                <footer class="modal-card-foot">
                    <b-button class="is-dvogreen" @click="updateItem()">Update Company</b-button>
                </footer>
            </div>
        </form>
    </div>
</template>

<script>
import { API } from 'aws-amplify';
import { companyHandler } from '../graphql/mutations'
export default {

    data() {
        return {
            companyObj: this.initCompanyObj
        }
    },
    props: ['initCompanyObj'],
    methods: {
        async updateItem() {
            this.companyObj['request_type'] = 'update';
            await API.graphql({
                query: companyHandler,
                variables: {
                    input: this.companyObj
                },
            });
            this.$emit('close');
        }
    }
}
</script>
